<script lang="ts">
  import { Key } from 'lucide-svelte';
</script>

<nav class="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-lg border-b border-white/5">
  <div class="max-w-7xl mx-auto px-4 md:px-8 py-4 md:py-5 flex items-center justify-between">
    <a href="#" class="flex items-center gap-3 hover:opacity-80 transition-opacity">
      <div class="bg-white p-2 rounded-md">
        <Key class="w-5 h-5 text-black" />
      </div>
      <span class="text-white tracking-tight">BuyKeys</span>
    </a>

    <div class="hidden md:flex items-center gap-12">
      <a href="#pricing" class="text-slate-400 hover:text-white transition-colors text-sm">
        Pricing
      </a>
      <a href="https://t.me/BuyKeysSupport" target="_blank" rel="noopener noreferrer" class="text-slate-400 hover:text-white transition-colors text-sm">
        Contact
      </a>
    </div>

    <div class="flex items-center gap-4">
      <a href="https://t.me/BuyKeysStore" target="_blank" rel="noopener noreferrer" class="px-4 md:px-6 py-2.5 bg-white text-black rounded-md transition-all hover:-translate-y-0.5 text-xs md:text-sm whitespace-nowrap inline-block" style="box-shadow: 0 4px 14px 0 rgba(255, 255, 255, 0.15), 0 8px 24px 0 rgba(255, 255, 255, 0.1)">
        Join Community
      </a>
    </div>
  </div>
</nav>
